export const state = () => {
	return {
		challenge_creators: [],
		count: 0,
		missionsCount: 0,
	}
}

export const actions = {
	async list_paginate({ commit }, { companyId, params }) {
		const {
			social_networks: socialNetworks,
			type_challenges: typeChallenges,
			limit,
			...restParams
		} = params

		let searchUrl = `api/company/${companyId}/challenge-creators/?limit=${limit}`

		if (socialNetworks) {
			socialNetworks.forEach((sn) => (searchUrl += `&social_networks[]=${sn}`))
		}
		if (typeChallenges) {
			typeChallenges.forEach((tc) => (searchUrl += `&type_challenges[]=${tc}`))
		}

		return await useNuxtApp()
			.$api(searchUrl, { params: restParams })
			.then((res) => {
				commit('set', res.results)
				return res
			})
	},

	async count({ commit }, { companyId, params }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/challenge-creators/`, { params })
			.then((res) => {
				commit('setCount', res.count)
				return res
			})
	},

	async getMissionsCount({ commit }, { companyId }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/challenge-creators/stats-missions/`)
			.then(({ mission_count: count }) => {
				commit('setMissionsCount', count)
				return count
			})
			.catch((err) => {
				commit('setMissionsCount', 0)
				throw err
			})
	},

	async list({ commit }, { companyId, params }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/challenge-creators/`, { params })
			.then((res) => {
				commit('set', res.results)
				return res
			})
	},

	async get_page({ commit }, { pageURL }) {
		return await useNuxtApp()
			.$api(pageURL)
			.then((res) => {
				commit('set', res.results)
				return res
			})
	},

	async partial_update(_, { companyId, ccId, data }) {
		return await useNuxtApp().$api(`api/company/${companyId}/challenge-creators/${ccId}/`, {
			method: 'PATCH',
			body: data,
		})
	},
	async create(_, { companyId, data }) {
		return await useNuxtApp().$api(`api/company/${companyId}/challenge-creators/`, {
			method: 'POST',
			body: data,
		})
	},
}

export const mutations = {
	set(state, data) {
		state.challenge_creators = data
	},
	setCount(state, data) {
		state.count = data
	},
	setMissionsCount(state, data) {
		state.missionsCount = data
	},
}
